import React, { Component } from 'react';
import {
  V2FavoriteSelectedIcon,
  V2FavoriteIcon,
  Toast,
} from '@paypalcorp/pp-react';
import styles from './SetPreferredHeart.less';

export default class SetPreferredHeart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToastPreferredMessage: this.props.showToastPreferredMessage,
      isPreferredCharitySwitch: this.props.isPreferredCharitySwitch,
    };
  }

  getToastPreferredMessage() {
    if (this.props.hasError) {
      return this.props.errorMessage;
    }

    if (!this.props.selected) {
      return this.props
        .i18n('toast.no-longer-preferred-charity')
        .replace('{charityName}', this.props.charityName);
    }

    if (this.props.selected && this.state.isPreferredCharitySwitch) {
      return this.props
        .i18n('toast.new-preferred-charity')
        .replace('{charityName}', this.props.charityName);
    }
    return this.props.i18n('toast.preferred-charity');
  }

  componentWillUnmount() {
    this.setState({
      showToastPreferredMessage: false,
      isPreferredCharitySwitch: false,
    });
  }

  renderHeartIcon() {
    return this.props.selected ? (
      <V2FavoriteSelectedIcon
        alt={this.props.i18n('label.preferred-charity')}
        role='link'
        aria-label={this.props.i18n('label.preferred-charity')}
        className={styles['heart-filled']}
        name='favorite-selected'
        data-nemo='npo-heart-filled'
        size='sm'
        as='svg'
      />
    ) : (
      <V2FavoriteIcon
        alt={this.props.i18n('label.set-preferred')}
        role='link'
        aria-label={this.props.i18n('label.set-preferred')}
        className={styles['heart-empty']}
        name='favorite'
        size='sm'
        as='svg'
      />
    );
  }

  render() {
    return (
      <>
        {this.state.showToastPreferredMessage && (
          <Toast
            key='toast_success'
            id='toast_success'
            message={this.getToastPreferredMessage()}
            isSuccess={this.props.selected && !this.props.hasError}
            theme='v2'
          />
        )}
        {this.renderHeartIcon()}
      </>
    );
  }
}
